import styled from 'styled-components';

export const Container = styled.div`
  padding: 0px 50px;
  margin: 0 auto 35px;

  a {
    text-decoration: none;
    color: #272727;
  }

  @media (max-width: 980px) {
    padding: 0 20px 0 20px;
  }
`;

export const CarouselSection = styled.section`
  margin-bottom: 48px;
`;

export const CarouselTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #020c90;
  text-transform: capitalize;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 3px solid #ffcb29;
  display: inline-block;

  @media (max-width: 980px) {
    font-size: 18px;
  }
`;

export const CarouselWrapper = styled.div`
  width: 100%;
`;

export const CarouselNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;

  span {
    font-size: 14px;
    color: #9a9a9a;
    font-weight: 600;
  }
`;

export const CarouselNavBtn = styled.button`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background-color: #020c90;
  color: #ffffff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #ffcb29;
    color: #020c90;
  }

  &:disabled {
    background-color: #d9d9d9;
    color: #9a9a9a;
    cursor: not-allowed;
  }
`;
